module.exports = __webpack_public_path__ + "assets/img/report-act-bg-3.e4b92e40.png";